<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <slot name="header"></slot>

      <slot name="after-report-advanced"></slot>

      <ReportQRCodeA4Enterprise v-if="relationAccessSubValidation('sub-place-report-qrcode-A4-enterprise')"/>
      <ReportQRCodePimaco4083Enterprise
          v-if="relationAccessSubValidation('sub-place-report-qrcode-pimaco4083-enterprise')"/>
      <ReportExtractEnterprise v-if="relationAccessSubValidation('sub-place-report-extract-item-by-enterprise')"/>

      <slot name="footer"></slot>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import ReportExtractEnterprise from "@/views/modules/place/Report/ReportExtractEnterprise";
import ReportQRCodeA4Enterprise from "@/views/modules/place/Report/ReportQRCodeA4Enterprise";
import ReportQRCodePimaco4083Enterprise from "@/views/modules/place/Report/ReportQRCodePimaco4083Enterprise";

export default {
  mixins: [pageDefaultMixin],
  components: {ReportExtractEnterprise, ReportQRCodeA4Enterprise, ReportQRCodePimaco4083Enterprise},
  name: 'PlaceReport',
  data() {
    return {}
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
